import { default as PaymentPrebuiltPage } from './payment-prebuilt';

export default {
  PaymentPrebuiltPage
}